<template>
  <v-data-table class="elevation-1"
            :headers="headers"
            :items="items"
            :loading="loading"
            hide-actions
            :no-data-text="$t('noDataAvailable')">
    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
    <template v-slot:items="props">
      <td> {{ props.item.sequential_id || props.item.id }} </td>
      <td> {{ props.item.name }} </td>
      <td> {{ props.item.provider.name }} </td>
      <td>
        <StatusChip :status="props.item.status" outline></StatusChip>
      </td>
      <td class="pa-0 pr-2 text-xs-right">

        <v-tooltip slot="append" :disabled="!props.item.shipment_disabled" max-width="300px" min-width="200px" bottom>
          <v-btn color="success" :disabled="props.item.shipment_disabled" slot="activator" flat icon @click="activate(props.item)" v-if="props.item.status !== 'active'">
            <font-awesome-icon icon="check"></font-awesome-icon>
          </v-btn>
          <span>
            {{ $t('shipmentLimit', {shipmentCount: props.item.shipment_count}) }}
          </span>
        </v-tooltip>

        <v-btn color="red" flat icon @click="suspend(props.item)" v-if="props.item.status !== 'suspended'">
          <font-awesome-icon icon="ban"></font-awesome-icon>
        </v-btn>

        <v-btn color="primary" flat icon @click="goTo('carrierSettings', { carrierId: props.item.id })">
          <font-awesome-icon icon="cog"></font-awesome-icon>
        </v-btn>

        <v-btn color="primary" flat icon @click="goTo('services', { carrierId: props.item.id })">
          <font-awesome-icon icon="truck"></font-awesome-icon>
        </v-btn>

        <v-btn color="primary" v-if="canDownload(props.item)" flat icon @click="exportCarrierInfo(props.item)">
          <font-awesome-icon icon="download"></font-awesome-icon>
        </v-btn>

        <v-btn color="primary" flat icon @click="goTo('editCarrier', props.item.id)">
          <font-awesome-icon icon="edit"></font-awesome-icon>
        </v-btn>

        <v-btn color="red" flat icon @click="destroy(props.item)" v-if="$auth.isDev()" v-can:destroy="'Carrier'">
          <font-awesome-icon icon="times"></font-awesome-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import Carrier from '@/client/carrier'

export default {
  name: 'CarriersView',

  props: {
    status: {
      default: '',
      type: String,
      required: true
    }
  },

  data () {
    return {
      headers: [
        { text: '#', align: 'left', sortable: true, value: 'sequential_id', width: '5%' },
        { text: this.$t('attrs.name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$tc('models.provider'), align: 'left', sortable: true, value: 'provider.name' },
        { text: this.$t('attrs.status'), align: 'left', sortable: true, value: 'status' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      items: [],
      loading: false
    }
  },

  components: {

  },

  computed: {

  },

  methods: {
    async fetch () {
      this.loading = true
      var payload = { include: 'provider', per_page: 2000 }

      if (this.status === 'active' || this.status === 'suspended') {
        payload.where = { status: this.status }
      }

      this.items = await Carrier.all(payload)
      this.loading = false
    },

    async destroy (carrier) {
      try {
        if ( this.confirmation(carrier) ) {
          await Carrier.destroyById(carrier.id)
          await this.fetch()
        }
      } catch (err) {
        // handleErr
      }
    },

    async activate (carrier) {
      try {
        carrier.status = 'active'
        await carrier.save()
      } catch (err) {
        // empty
      }
      await this.fetch()
    },

    async suspend (carrier) {
      try {
        carrier.status = 'suspended'
        await carrier.save()
      } catch (err) {
        // empty
      }
      await this.fetch()
    },

    async exportCarrierInfo (carrier) {
      try {
        const data = await Carrier.exportCarrierInfo(carrier.id)
        this.downloadFile(data, `${carrier.name}-carrier.json`)
      } catch (err) {
        this.handleBlobErr(err)
      }
    },

    confirmation (carrier) {
      return window.confirm(this.$t('deleteConfirmation', { name: carrier.name, obj: this.$tc('models.carrier', 1).toLowerCase() }))
    },

    handleBlobErr (err) {
      const self = this
      if (err.response) {
        const blob = err.response.data
        const reader = new FileReader()

        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement.result
          self.handleErr({ response: { data: JSON.parse(text) } })
        })

        reader.readAsText(blob)
      } else {
        this.handleErr(err)
      }
    },

    downloadFile (data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    canDownload (carrier) {
      return this.$auth.isDev()
    },
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
